import React, {Component} from 'react';
import i from '../imports';

const messageStyle = {
    fontStyle: "italic",
    fontSize: 16,
    paddingBottom: 10,
    paddingLeft: 10,
    // paddingRight: 10,
    textAlign: "right",
    // marginRight: -15
}

const photoStyle = {
    margin: 0,
    borderRadius: '50% 50%',
    width: 100,
    height: 100,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    textAlign: "center"
}

const itemStyle = {
    marginTop: 15,
    marginBottom: 15,
    paddingTop: 20,
    paddingBottom: 20
}

class TestimonialItem extends Component {
    render() {
        let item = this.props.item;
        return (
            <i.Row justify="center">
                <i.Col md={12} xs={12}>
                    <i.Container className="testimonial-item" style={itemStyle}>
                        <i.Row>
                            <i.Col md={7} xs={7}>
                                <div style={messageStyle}>{item.translations[0].testimonial}</div>
                                <div style={{textAlign: "right"}}>{item.translations[0].name}</div>
                            </i.Col>
                            <i.Col md={5} xs={5} align="left">
                                <div style={Object.assign({
                                    backgroundImage: `url('${item.photo}')`
                                }, photoStyle)}></div>
                            </i.Col>
                        </i.Row>
                    </i.Container>
                </i.Col>
            </i.Row>
        );
    }
}

export default TestimonialItem;